export default "__VITE_ASSET__Dc9$EcOp__"